<template>
	<el-form ref="formData" size="small" :rules="rules" status-icon :model="formData">
		<el-form-item align="left" prop="user_email" label="User Email:">
			{{ formData.user_email }}
		</el-form-item>
		<el-form-item align="left" prop="user_name" label="User Name:">
			{{ formData.user_name }}
		</el-form-item>
		<el-form-item align="left" prop="user_type" label="User Type:">
			<el-select style="width: 150px" size="small" v-model="formData.user_type" default-first-option>
				<el-option :key="0" label="admin" :value="1"> </el-option>
				<el-option :key="1" label="craftie admin" :value="2"> </el-option>
				<el-option :key="2" label="content admin" :value="3"> </el-option>
				<el-option :key="3" label="device content admin" :value="4"></el-option>
				<el-option :key="4" label="search admin" :value="5"> </el-option>
				<el-option :key="5" label="product admin" :value="6"></el-option>
			</el-select>
		</el-form-item>
		<el-form-item align="left" prop="user_status" label="User Status:">
			<el-select style="width: 150px" size="small" v-model.number="formData.user_status" default-first-option>
				<el-option :key="0" label="Disable" :value="0"> </el-option>
				<el-option :key="1" label="Activation" :value="1"> </el-option>
			</el-select>
		</el-form-item>
		<el-form-item align="right">
			<el-button @click="$emit('close', false)">Back</el-button>
			<el-button class="el-button--primary" @click="submit('formData')">Save</el-button>
		</el-form-item>
	</el-form>
</template>

<script>
export default {
	name: "AdminUserAdd",
	props: {
		close: Function,
		chooseItem: Object,
	},
	data() {
		return {
			formData: {
				uid: "",
				user_type: null,
				user_status: null,
			},
			rules: {},
		};
	},
	mounted() {
		let item = this.$util.fetch("item");
		this.formData = item;
	},
	methods: {
		submit(formName) {
			this.$refs[formName].validate((valid) => {
				if (!valid) {
					this.$message.warning("Please check the input data!");
					return
				}
				let loading = this.$util.loading();
				this.$api.rootV1.post(
					"/web/user/updatestatus",
					this.formData,
					(res) => {
						this.$alert("update successfully!", "info", {
							confirmButtonText: "confirm",
							type: "success",
							callback: (action) => {
								loading.close();
								this.$emit("close", true);
							},
						});
					},
					(res) => {
						this.$alert("update failed!", "info", {
							confirmButtonText: "confirm",
							type: "error",
							callback: (action) => {
								loading.close();
								this.$emit("close", false);
							},
						});
					}
				);
			});
		},
	},
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/main/adminUser/AdminUserUpdate.vue